// footer.jsx
import React, { useEffect, useCallback } from "react";
import { useState } from "react";
import ConfirmBet from "../confirmBet";
import Selection from "../selection";
import { useLocation } from "react-router-dom";
import { TbPlayFootball } from "react-icons/tb"
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
// Uncomment and provide the correct path for bettingService
import bettingService from "../../../api/services/bettingService";
import { playSong } from "../../common/actions/common.actions";
import { useDispatch } from "react-redux";
import Modal from "../../common/components/modal";
import { useSelector } from 'react-redux';
import { selectLoginData } from "../login/login.actions";
import { setConfirmData } from '../../common/actions/common.actions';
// Uncomment and provide the correct path for dashboardService
import dashboardService from "../../../api/services/dashboardService";

const Footer = ({
    selectedMatches,
    fromBody = false,
    showToastMessage,
    handleRemoveCard,
    onModalTitleChange,
    onModalContentChange,
    onOpenModalChange
}) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [showSelectedMatches, setShowSelectedMatches] = useState(false);
    const [showConfirmScreen, setShowConfirmScreen] = useState(false);
    const [betAmount, setBetAmount] = useState('');
    const [maxBetAmount, setMaxBetAmount] = useState(0);
    const [minBetAmount, setMinBetAmount] = useState(0);
    const [balance, setBalance] = useState(0);

    const handleSongClick = useCallback(() => {
        dispatch(playSong());
    }, [dispatch]);

    const handleConfirmData = useCallback((data) => {
        dispatch(setConfirmData(data));
    }, [dispatch]);

    const { userDetails } = useSelector(selectLoginData);
    const { confirmData } = useSelector((state) => state.common);

    useEffect(() => {
        if (userDetails) {
            const userDetail = userDetails;
            setBalance(userDetail.balance);
            if (fromBody) {
                setMaxBetAmount(userDetail.betLimitForSingle);
            } else {
                setMaxBetAmount(userDetail.betLimitForMix);
            }
            if (confirmData) {
                setBetAmount(confirmData.betAmount || '');
            }
        }
    }, [userDetails, fromBody, confirmData]);

    const openModal = (title, content) => {
        if (onModalTitleChange && onModalContentChange && onOpenModalChange) {
            onModalTitleChange(title);
            onModalContentChange(content);
            onOpenModalChange(true);
        }
    };

    const closeModal = () => {
        if (onOpenModalChange) {
            onOpenModalChange(false);
        }
    };

    const validation = (gamblingTypeInfo) => {
        if (!selectedMatches || (selectedMatches && selectedMatches.length < 1)) {
            return "Please choose at least 1 match!";
        } else if (betAmount && parseFloat(betAmount) > balance) {
            return `Bet amount should be less than your balance: ${balance}!`;
        } else if (betAmount && parseFloat(betAmount) > maxBetAmount) {
            return `Bet amount should be less than ${maxBetAmount}!`;
        } else if (location.pathname === '/maungg') {
            if (selectedMatches && selectedMatches.length < 2) {
                return "Please choose at least 2 matches!";
            }
        }
        return null;
    };

    const fetchLock = async () => {
        try {
            const userId = Number(userDetails.userId);
            // Uncomment when you have dashboardService
            // const response = await dashboardService.getBalanceForDashboard(userId).then((response) => response.json());
            // if (response.userInfo) {
            //   const updatedUserDetails = response.userInfo[0];
            //   if (updatedUserDetails.lock) {
            //     localStorage.removeItem('token');
            //     localStorage.removeItem('userDetails');
            //     localStorage.removeItem('confirmData');
            //     navigate("/login");
            //   }
            // }
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        if (userDetails) {
            fetchLock();
        }
    }, [userDetails]);

    const handleConfirm = async () => {
        try {
            fetchLock();
            //const response = await bettingService.getMinMax();
            const response = await bettingService.getMinMax2();
            if (!response.ok) {
                throw new Error("Failed to fetch min/max bet amounts.");
            }
            const data = await response.json();
            const gamblingTypeInfo = data.gamblingType.find(typeInfo => typeInfo.gamblingTypeId === (fromBody ? 1 : 2));
            if (gamblingTypeInfo) {
                setMinBetAmount(gamblingTypeInfo.minBetAmount);
            }
            const error = validation(gamblingTypeInfo);
            const mixLimit = data.gamblingLimit[selectedMatches.length - 1]?.betLimit;
            if (error) {
                openModal('EP SPORTS', error);
                return;
            }

            if (betAmount < gamblingTypeInfo.minBetAmount) {
                openModal('EP SPORTS', `Bet amount should be greater than ${gamblingTypeInfo.minBetAmount}!`);
                return;
            }
            if (betAmount && betAmount > mixLimit) {
                openModal('EP SPORTS', `Bet amount for ${selectedMatches.length} mix should not be greater than ${mixLimit}!`);
                return;
            }
            handleConfirmData({ betAmount, selectedMatches, isMix: location.pathname === '/maungg' ? true : false });
            handleSongClick();
            navigate("/confirm-bet");
        } catch (error) {
            console.error("Error fetching min/max bet amounts:", error);
        }
    };

    const handleBetAmountChange = useCallback((e) => {
        if (e.target.value !== '' && e.target.value !== '0') {
            const value = Math.floor(parseFloat(e.target.value));
            if (value > maxBetAmount || value > balance) {
                return;
            }
            setBetAmount(value.toString());
        } else {
            setBetAmount('');
        }
    }, [maxBetAmount, balance]);

    return (
        <div className="flex items-center justify-between h-20 px-2">
            <label className="text-blue-primary font-bold whitespace-nowrap px-1 mx-[1px] text-sm">{t('betAmount')}</label>
            <input
                type="number"
                inputMode='numeric'
                value={betAmount}
                onChange={handleBetAmountChange}
                className="w-1/2 h-10 mx-[2px] pr-1 border-2 border-crimson/30 rounded-xl focus:outline-none focus:border-crimson focus:ring-2 focus:ring-crimson/20 text-blue-primary bg-white/90 text-right font-bold transition-all duration-300"
            />
            <button className="z-50" onClick={handleConfirm}>
                <div className="cursor-pointer flex items-center justify-center bg-gradient-to-br from-crimson via-red-primary to-crimson text-white border-2 border-golden/40 hover:shadow-xl transition-all duration-300 px-4 py-2 mx-[2px] rounded-xl whitespace-nowrap font-bold shadow-lg">
                    {t('bet')}
                </div>
            </button>
            {location.pathname === '/maungg' && (
                <div className="flex text-white bg-gradient-to-br from-blue-primary via-blue-dark to-blue-primary border-2 border-golden/40 py-2 px-3 w-12 mx-[1px] rounded-xl justify-center items-center font-bold shadow-lg">
                    <span>{selectedMatches.length}</span>
                </div>
            )}
        </div>
    );
};

export default Footer;